import { BREAKPOINTS } from "@/settings";
import { useMediaQuery } from "usehooks-ts";

import { PlayStyle } from "./Shared";

interface PlayStylesSectionProps {
  playStylesPlus: number[];
  playStyles: number[];
}

export const PlayStylesSection = ({
  playStylesPlus,
  playStyles,
}: PlayStylesSectionProps) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  return (
    <div className="flex flex-wrap col-span-4 mobile:col-span-3 gap-2 mobile:gap-4 bg-panel-background mobile:bg-transparent px-4 py-2 rounded-b-md">
      {playStylesPlus?.map((id) => (
        <PlayStyle
          hasPlus={true}
          hasNormal={false}
          id={id}
          large={!isMobile}
          key={id}
        />
      ))}
      {playStyles?.map((id) => (
        <PlayStyle
          hasPlus={false}
          hasNormal={true}
          id={id}
          large={!isMobile}
          key={id}
        />
      ))}
    </div>
  );
};
